import { ILastState } from '../../state/types';
import { makeFetch } from './_shared/fetchMakers';
import { normalizeAndTranslateSingleEntity } from './_shared/normalizers';
import { makeTaskUrl } from './_shared/urlMakers';

export const fetchTask = makeFetch<ILastState>(
    makeTaskUrl,
    normalizeAndTranslateSingleEntity
);
